// src/context/UserContext.js
import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState('');
  const [username, setUsername] = useState('');
  const [menuId, setMenuId] = useState(null); // ✅ 추가
  const [commCode, setCommCode] = useState('');
  const [commMsg, setCommMsg] = useState('');
  const [permId, setPermId] = useState('');

  return (
    <UserContext.Provider value={{ username, setUsername, menuId, setMenuId, commCode, setCommCode, userId, setUserId, permId, setPermId, commMsg, setCommMsg }}>
      {children}
    </UserContext.Provider>
  );
};
